import {Component, Input} from '@angular/core';
import {Contact} from '../models/contact';

@Component({
  selector: 'contact-list',
  template: `
    <div class="row">
      <div class="col-md-12 text-right">
        <a routerLink="editor"><i class="fa fa-plus"></i> Add New Contact</a>
      </div>
    </div>
    <div class="row header">
      <div class="col-md-2">Last Name</div>
      <div class="col-md-2">First Name</div>
      <div class="col-md-3">Email</div>
      <div class="col-md-3">Telephone</div>
      <div class="col-md-2">&nbsp;</div>
    </div>
    <div class="row line-item" *ngFor="let c of contacts">
      <div class="col-md-2">{{c.lastname}}</div>
      <div class="col-md-2">{{c.firstname}}</div>
      <div class="col-md-3">{{c.email}}</div>
      <div class="col-md-3">{{c.phone}}</div>
      <div class="col-md-2 text-right">
        <a [routerLink]="['editor', c.id]"><i class="fa fa-pencil"></i> Edit</a>
      </div>
    </div>
  `,
  styles: [`
    .header {
      margin-bottom: 5px;
      border-bottom: 1px solid #666;
      font-weight:bold;
    }
    .line-item {
      border-bottom: 1px solid #ccc;
      margin-bottom:3px;
      padding-bottom:3px;
    }
  `]
})
export class ContactListComponent {
  @Input() contacts: Contact[];

}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/contact-list.ts